<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="分红ID">-->
<!--                  <el-input  v-model="queryForm.incomeId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="当天日期">
                  <el-input  v-model="queryForm.dayDate"></el-input>
              </el-form-item>
              <el-form-item label="总的分红金额">
                  <el-input  v-model="queryForm.totalMoney"></el-input>
              </el-form-item>
              <el-form-item label="总积分数量">
                  <el-input  v-model="queryForm.totalScore"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getModelTeamIncomeSendRecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addModelTeamIncomeSendRecord"
        >新建</el-button>
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editModelTeamIncomeSendRecord(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteModelTeamIncomeSendRecord(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportModelTeamIncomeSendRecordList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshModelTeamIncomeSendRecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="modelTeamIncomeSendRecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="incomeId"-->
<!--        label="分红ID"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="dayDate"
        label="当天日期"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalMoney"
        label="总的分红金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="totalScore"
        label="总积分数量"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
<!--            <div @click="checkModelTeamIncomeSendRecord(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editModelTeamIncomeSendRecord(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="openModelTeamIncomeUserRecord(scop.row.id)">
              <span class="operation-label">发放用户</span>
            </div>
            <div @click="deleteModelTeamIncomeSendRecord(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="modelTeamIncomeSendRecordStates[modelTeamIncomeSendRecordState]"
      :visible.sync="showDialog"
      :append-to-body="true"
      width="400px"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="modelTeamIncomeSendRecord"
          ref="modelTeamIncomeSendRecordForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="分红ID"-->
<!--            prop="incomeId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="modelTeamIncomeSendRecord.incomeId"-->
<!--              :disabled="modelTeamIncomeSendRecordState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="当天日期"
            prop="dayDate"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="modelTeamIncomeSendRecord.dayDate"-->
<!--              :disabled="modelTeamIncomeSendRecordState == 'check'"-->
<!--            ></el-input>-->
              <el-date-picker
                  style='width: 177px'
                  v-model='modelTeamIncomeSendRecord.dayDate'
                  :disabled="modelTeamIncomeSendRecordState == 'check'"
                  type='date'
                  format='yyyy-MM-dd'
                  value-format='yyyy-MM-dd'
                  placeholder='选择日期时间'>
              </el-date-picker>
          </el-form-item>
          <el-form-item
            label="总的分红金额"
            prop="totalMoney"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncomeSendRecord.totalMoney"
              :disabled="modelTeamIncomeSendRecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="总积分数量"
            prop="totalScore"
          >
            <el-input
              size="small"
              style='width: 177px'
              v-model="modelTeamIncomeSendRecord.totalScore"
              :disabled="modelTeamIncomeSendRecordState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="modelTeamIncomeSendRecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
      <el-drawer title="发放用户" :append-to-body="true" :visible.sync="isShowUserRecord" direction="rtl" size="70%"
                 :before-close="closeModelTeamIncomeRecord">
          <ModelTeamIncomeUserRecord ref="modelTeamIncomeUserRecord" />
      </el-drawer>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import ModelTeamIncomeUserRecord from "@/components/model/ModelTeamIncomeUserRecord.vue";

export default {
    components: {
        ModelTeamIncomeUserRecord,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelTeamIncomeSendRecordList();
                    this.getModelTeamIncomeSendRecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelTeamIncomeSendRecordList();
                    this.getModelTeamIncomeSendRecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     id: '', //
                     incomeId: '', //分红ID
                     dayDate: '', //当天日期
                     totalMoney: '', //总的分红金额
                     totalScore: '', //总积分数量
                     createUserId: '', //
                     createTime: '', //
                     updateUserId: '', //
                     updateTime: '', //
                     deleteFlag: '', //
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelTeamIncomeSendRecordState: 'add',
                modelTeamIncomeSendRecordStates: {
                    add: '新建model_team_income_send_record',
                    check: '查看model_team_income_send_record',
                    edit: '修改model_team_income_send_record'
                },

                multipleSelection: [],
                modelTeamIncomeSendRecordList: [],
                modelTeamIncomeSendRecord: {
                    id: '', //
                    incomeId: '', //分红ID
                    dayDate: '', //当天日期
                    totalMoney: '', //总的分红金额
                    totalScore: '', //总积分数量
                    createUserId: '', //
                    createTime: '', //
                    updateUserId: '', //
                    updateTime: '', //
                    deleteFlag: '', //
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    incomeId: [{ required: true, message: '分红ID不能为空', trigger: 'blur' }],
                    dayDate: [{ required: true, message: '当天日期不能为空', trigger: 'blur' }],
                    totalMoney: [{ required: true, message: '总的分红金额不能为空', trigger: 'blur' }],
                    totalScore: [{ required: true, message: '总积分数量不能为空', trigger: 'blur' }],
                    createUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    deleteFlag: [{ required: true, message: '不能为空', trigger: 'blur' }],
                },

                isShowUserRecord: false,
            };
        },
        created() {
            // this.getModelTeamIncomeSendRecordList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(id){
                this.modelTeamIncomeSendRecord.incomeId = id;
                this.queryForm.incomeId = id;
                this.getModelTeamIncomeSendRecordList();
            },
            openModelTeamIncomeUserRecord(id) {
                this.isShowUserRecord = true;
                this.$nextTick(()=>{
                    this.$refs.modelTeamIncomeUserRecord.init(this.queryForm.incomeId ,id)
                })
            },
            closeModelTeamIncomeRecord() {
                this.isShowUserRecord = false;
            },
            resetModelTeamIncomeSendRecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.modelTeamIncomeSendRecordList = [];
            },
            resetDialog() {
                this.modelTeamIncomeSendRecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      incomeId: this.queryForm.incomeId, //分红ID
                      dayDate: '', //当天日期
                      totalMoney: '', //总的分红金额
                      totalScore: '', //总积分数量
                };
                this.getModelTeamIncomeSendRecordList();
            },
            closeDialog() {
                this.showDialog = false
                this.modelTeamIncomeSendRecord = {
                      id: '', //
                      incomeId: this.modelTeamIncomeSendRecord.incomeId, //分红ID
                      dayDate: '', //当天日期
                      totalMoney: '', //总的分红金额
                      totalScore: '', //总积分数量
                };
            },
            submitForm() {
                if (this.modelTeamIncomeSendRecordState == 'add') {
                    this.$refs.modelTeamIncomeSendRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/teamincomesendrecord/add`,{ ...this.modelTeamIncomeSendRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelTeamIncomeSendRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelTeamIncomeSendRecordState == 'edit') {
                    this.$refs.modelTeamIncomeSendRecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/teamincomesendrecord/edit`,{ ...this.modelTeamIncomeSendRecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelTeamIncomeSendRecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addModelTeamIncomeSendRecord() {
                this.showDialog = true;
                this.modelTeamIncomeSendRecordState = 'add';
            },
            checkModelTeamIncomeSendRecord(modelTeamIncomeSendRecordId) {
                console.log(modelTeamIncomeSendRecordId);
                this.currentModelTeamIncomeSendRecordId = modelTeamIncomeSendRecordId;

                this.getModelTeamIncomeSendRecordById();
                this.showDialog = true;
                this.modelTeamIncomeSendRecordState = 'check';
            },
            editModelTeamIncomeSendRecord(modelTeamIncomeSendRecordId) {
                console.log('modelTeamIncomeSendRecord', modelTeamIncomeSendRecordId);
                if (modelTeamIncomeSendRecordId) {
                    this.currentModelTeamIncomeSendRecordId = modelTeamIncomeSendRecordId;
                    this.getModelTeamIncomeSendRecordById();
                } else {
                    this.modelTeamIncomeSendRecord = { ...this.modelTeamIncomeSendRecord, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelTeamIncomeSendRecordState = 'edit';
            },
            deleteModelTeamIncomeSendRecord(modelTeamIncomeSendRecordId) {
                let ids = '';
                if (modelTeamIncomeSendRecordId) {
                    ids = modelTeamIncomeSendRecordId;
                } else {
                    ids = this.multipleSelection.map((modelTeamIncomeSendRecord) => modelTeamIncomeSendRecord.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/teamincomesendrecord/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelTeamIncomeSendRecordList();
                                this.getModelTeamIncomeSendRecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelTeamIncomeSendRecordList() {
                this.resetModelTeamIncomeSendRecordList();
                this.getModelTeamIncomeSendRecordList();
            },
            getModelTeamIncomeSendRecordList(query = {}) {
                this.loading = true;
                get(`/model/teamincomesendrecord/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelTeamIncomeSendRecordList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelTeamIncomeSendRecordById() {
                get(`/model/teamincomesendrecord/get`,{ id: this.currentModelTeamIncomeSendRecordId }).then((res) =>{
                    if(res.success){
                      this.modelTeamIncomeSendRecord = { ...this.modelTeamIncomeSendRecord, ...res.modelTeamIncomeSendRecord };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelTeamIncomeSendRecordList() {
                //this.btnLoading = true;
                exprotExcel(`/model/teamincomesendrecord/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/teamincomesendrecord/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/teamincomesendrecord/importData`,formData);
              this.refreshModelTeamIncomeSendRecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelTeamIncomeSendRecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelTeamIncomeSendRecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>